import type { VariantProps } from 'class-variance-authority'

import React from 'react'
import { cva } from 'class-variance-authority'
import { Slot } from 'radix-ui'

import { cn } from '@/shared/lib/utils'

const linkButtonVariants = cva(
	'inline-flex cursor-pointer items-center text-sm gap-1 border-none bg-transparent font-medium no-underline hover:underline',
	{
		variants: {
			variant: {
				brand: 'text-primary hover:text-primary hover:decoration-primary',
				inverse: 'text-white hover:text-white',
				neutral: 'text-foreground hover:text-primary hover:decoration-primary',
			},
			size: {
				default: '[&>svg]:size-4',
				sm: 'text-xs [&>svg]:size-4',
				lg: 'text-md',
			},
		},
		defaultVariants: {
			variant: 'neutral',
			size: 'default',
		},
	}
)
type LinkButtonVariantsProps = VariantProps<typeof linkButtonVariants>
const LinkButton = ({
	children,
	className,
	size,
	variant,
	asChild,
	type = 'button',
	...otherProps
}: React.ComponentProps<'button'> &
	LinkButtonVariantsProps & {
		asChild?: boolean
	}) => {
	const Comp = asChild ? Slot.Root : 'button'

	return (
		<Comp
			className={cn(linkButtonVariants({ size, variant }), className)}
			type={type}
			{...otherProps}
		>
			{children}
		</Comp>
	)
}
LinkButton.displayName = 'LinkButton'
export { LinkButton, linkButtonVariants, type LinkButtonVariantsProps }
